module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Potatoes Not Prozac")]), _vm._v(" is")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_vm._v("dedicated to the countless people")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("whose fierce desire to heal lead us all")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("to deeper knowledge of a solution")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("that changes lives")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5126efb1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 72
// module chunks = 0